import { render, staticRenderFns } from "./TaskQRCode.vue?vue&type=template&id=0afac10a"
import script from "./TaskQRCode.vue?vue&type=script&lang=js"
export * from "./TaskQRCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afac10a')) {
      api.createRecord('0afac10a', component.options)
    } else {
      api.reload('0afac10a', component.options)
    }
    module.hot.accept("./TaskQRCode.vue?vue&type=template&id=0afac10a", function () {
      api.rerender('0afac10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/task/TaskQRCode.vue"
export default component.exports